/** Globale bus: open de zwevende assistent met vooringevulde tekst (b.v. na tekeninganalyse). */
export const ASSISTANT_OPEN_EVENT = 'calqtool-assistant-open';

export type AssistantOpenDetail = { draft: string };

export function openAssistantWithDraft(draft: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<AssistantOpenDetail>(ASSISTANT_OPEN_EVENT, { detail: { draft } }));
}
